import {FC} from 'react';
import {ArrowIcon, CloseIcon} from 'shared/icons';
import {Progress} from './Progress/Progress';
import styles from './Header.module.css';

type Props = {
	currentStep: number;
	totalSteps: number;
	onBack?: () => void;
	onClose?: () => void;
	showProgress?: boolean;
};

export const Header: FC<Props> = ({
	currentStep,
	totalSteps,
	onBack,
	onClose,
	showProgress = true,
}) => {
	return (
		<header className={styles.root}>
			{onBack ? (
				<button type="button" className={styles.iconButton} onClick={onBack} aria-label="Назад">
					<ArrowIcon className={styles.icon} />
				</button>
			) : null}
			{showProgress ? (
				<Progress
					currentStep={currentStep}
					totalSteps={totalSteps}
					align={onBack ? 'center' : 'start'}
					className={styles.progress}
				/>
			) : (
				<span className={styles.progress} aria-hidden />
			)}
			{onClose ? (
				<button type="button" className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
					<CloseIcon className={styles.closeIcon} />
				</button>
			) : null}
		</header>
	);
};
